module.exports = __webpack_public_path__ + "static/media/Lato-Regular.6d4e7822.ttf";